import { render, staticRenderFns } from "./FormBrand.vue?vue&type=template&id=e091c74c&scoped=true&lang=pug"
import script from "./FormBrand.vue?vue&type=script&lang=js"
export * from "./FormBrand.vue?vue&type=script&lang=js"
import style0 from "./FormBrand.vue?vue&type=style&index=0&id=e091c74c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e091c74c",
  null
  
)

export default component.exports